import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useResourcesQuery = createQueryHook(MembershipsCreatorApiClient.getResources, {
  queryKey: ['resources'],
})
